module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-50.14e81e5c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-50.png
// module id = 3337
// module chunks = 11